import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import DebouncedButton from "features/common/DebouncedButton";
import FormattedMessage from "features/common/TranslatedMessage";
import Question from "features/singleDispute/Question";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { createAnswers as createAnswersAndUpdateCase, editAnswersInBluk } from "slices/answerSlice";
import { DocGenerator } from "utils";
import { useStyles } from "./styles";
import isEmpty from "lodash/isEmpty";
import { format, parseISO } from "date-fns";
import { Typography } from "@material-ui/core";
import { isDigipub, isHotStar, isMuthoot, isOrix, isStar } from "Routes/Routes";
import { useResumeFilling } from "contexts/ResumeFilling";
import { getSubQuestions } from "slices/questionSlice";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const Questions = ({
  questions,
  activeDispute,
  activeCase,
  answerLoading,
  profile,
  answerValues,
  updateAnswerValues,
  fetchedAnswers = [],
}) => {
  let dispatch = useDispatch();
  let location = useLocation();
  let history = useHistory();
  const classes = useStyles();
  // const answerValues = new Map();
  const { setResume } = useResumeFilling();

  useEffect(()=>{
    questions.forEach((question)=>{
      if(!answerValues.has(question.id)) {
        if (question.optional) {
          if (question.type === "boolean") {
            updateAnswerValues(question.id, false);
          } else if (question.pre_filled) {
            updateAnswerValues(
              question.id,
              "Not aware to the best of my knowledge"
            );
          } else if (question.type === "date") {
            updateAnswerValues(question.id, null);
          } else if (question.type === "time_range") {
            updateAnswerValues(
              question.id,
              0 + ":" + 0 + ":" + 0 + " to " + 0 + ":" + 0 + ":" + 0
            );
          } else if (question.type === "simple") {
            updateAnswerValues(question.id, null);
          } else if (
            question.type === "radio" ||
            question.type === "dropdown" ||
            question.type === "number"
          ) {
            updateAnswerValues(question.id, null);
          }
        } else if (
          question.mandatory_boolean &&
          question.type === "boolean"
        ) {
          updateAnswerValues(question.id, false);
        } else if (!question.optional && question.type === "boolean") {
          updateAnswerValues(question.id, false);
        }
      }
    })
  },[questions, updateAnswerValues, answerValues])

  function checkMendatoryAnswer(questionId) {
    for (var entry of answerValues.entries()) {
      if (entry[0] === questionId) {
        return entry[1];
      }
    }
  }

  function checkMendatoryBoolean(questionId) {
    for (var entry of answerValues.entries()) {
      if (entry[0] === questionId) {
        return entry[1];
      }
    }
  }

  const onChange = (question, event) => {
    const value = event.target.value;
    if(isOrix && (question.name === 'Complaint Category')){
      dispatch(getSubQuestions(activeDispute.company_product, activeCase.type, value));
    }
  };

  const onSubmit = async (e) => {
    questions.map((question, index) => {
      if (
        !question.optional &&
        question.type !== "boolean" &&
        question.type !== "date"
      ) {
        var returned_ans = checkMendatoryAnswer(question.id);
        if (typeof returned_ans === "undefined") {
          alert(
            "Please fill mandatory field => " +
              question.name.substr(0, 40) +
              "...."
          );
          console.log(
            "returned_ans: " +
              returned_ans +
              " question.id: " +
              question.id +
              " type: " +
              typeof returned_ans
          );
        } else if (returned_ans === "" || returned_ans.trim() === "") {
          alert(
            "Please fill mandatory field => " +
              question.name.substr(0, 40) +
              "...."
          );
          console.log(
            "returned_ans: " +
              returned_ans +
              " question.id: " +
              question.id +
              " type: " +
              typeof returned_ans
          );
          answerValues.delete(question.id);
        }
      }

      if (
        !question.optional &&
        question.mandatory_boolean &&
        question.type === "boolean"
      ) {
        var returned_ans = checkMendatoryBoolean(question.id);
        if (!returned_ans) {
          alert("Please Agree with: " + question.name.substr(0, 40) + "....");
          console.log(
            "returned_ans_bool => " +
              returned_ans +
              " question.id: " +
              question.id +
              " type: " +
              typeof returned_ans
          );
          answerValues.delete(question.id);
        }
      }

      if (!question.optional && question.type === "time") {
        let arr = answerValues.get(question.id).split(":");
        console.log("arr:::::", arr);
        if (arr[0] > 5 || arr[1] > 59 || arr[2] > 59) {
          console.log("returned ans: ", answerValues.get(question.id));
          alert("Please enter time less than 5:59:59");
          answerValues.delete(question.id);
        }
      }

      if (isDigipub && question.type === "date") {
        if (!answerValues.has(question.id)) {
          alert(
            "Please fill mandatory field => " +
              question.name.substr(0, 40) +
              "...."
          );
        }
      }

      if (question.type === "time_range") {
        let arr = answerValues.get(question.id).split("to");
        console.log("arr", arr);
        if (arr.length > 1) {
          let fromArr = arr[0].split(":");
          let toArr = arr[1].split(":");
          let fromTimeInSeconds =
            parseInt(fromArr[0]) * 60 * 60 +
            parseInt(fromArr[1]) * 60 +
            parseInt(fromArr[2]);
          let ToTimeInSeconds =
            parseInt(toArr[0]) * 60 * 60 +
            parseInt(toArr[1]) * 60 +
            parseInt(toArr[2]);
            if((fromTimeInSeconds >= ToTimeInSeconds) && fromTimeInSeconds>0) {
            alert(
              "Please enter 'from' time less than 'to' time in : " +
                question.name.substr(0, 40) +
                "...."
            );
            answerValues.delete(question.id);
          }
        }
      }
    });

    console.log("answerValues.size outside: ", answerValues.size);

    if (answerValues.size >= questions.length) {
      let createAnswerPayload = [];
      const currentQuestionIds = new Set(questions.map(q => q.id));
      
      for (var entry of answerValues.entries()) {
        // Only include answers for questions that exist in the current questions array
        if (currentQuestionIds.has(entry[0])) {
          createAnswerPayload.push({
            question: entry[0],
            value: entry[1] !== null ? entry[1].toString() : null,
            case: activeCase.id,
            ... (fetchedAnswers?.find(ans => ans.question === entry[0]) ? { id: fetchedAnswers?.find(ans => ans.question === entry[0])?.id } : {}),
          });
        }
      }

      let casePayload = {
        id: activeCase.id,
        case_status: "questions_complete",
      };

      // console.log("answerValues: ", answerValues);

      // alert("Yay! filled all");
      if(fetchedAnswers && fetchedAnswers.length > 0){
        await dispatch(
          editAnswersInBluk({ createAnswerPayload, casePayload })
        );
      } else {
        await dispatch(
          createAnswersAndUpdateCase({ createAnswerPayload, casePayload })
        );
      }
      if(isMuthoot || isOrix){
        setResume(true);
      }
    }
  };

  const handleGoBack = () => {
    const formData = location?.state?.formData || {
      company: activeDispute?.company || '',
      company_product_type: activeDispute?.company_product_type || '',
      company_product: activeDispute?.company_product || '',
      region: activeDispute?.region || null,
      type: activeDispute?.grievance_type || null,
      city: activeDispute?.city || null,
      state: activeDispute?.state || null,
      existingCustomer: activeDispute?.existing_customer !== undefined ? activeDispute.existing_customer : true,
      loanNumber: activeDispute?.loan_or_booking_number || '',
      organizationName: activeDispute?.organization_name || '',
      helpDeskComplainRaised: activeDispute?.help_desk_complaint_raised !== undefined ? activeDispute.help_desk_complaint_raised : true,
      ticketNumber: activeDispute?.request_ticket_number || '',
      businessVertical: activeDispute?.business_vertical || '',
      loanType: activeDispute?.customer_type || '',
      sourceOfComplaint: activeDispute?.source_of_complaint || '',
    }
    history.push({
      pathname: '/intro',
      state: {
        formData: formData,
        disputeId: activeDispute?.id,
      }
    })
  }

  return (
    <React.Fragment>
      <Box textAlign="center" m="0 auto">
        <Grid container>
          <Grid item xs sm md={2}></Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={8}
            data-testid={`Claimant-arbitration-questions`}
          >
            <Box height="1rem"></Box>
            {questions.map((question, index) => {
              return (
                <Paper key={question.id} className={classes.paper}>
                  <Question
                    index={index}
                    question={question}
                    answerValues={answerValues}
                    profile={profile}
                    updateAnswerValues={updateAnswerValues}
                    onChange={onChange}
                    activeDispute={activeDispute}
                  />
                </Paper>
              );
            })}
          </Grid>
          <Grid item xs sm md={2}></Grid>
        </Grid>

        {profile.profile_type == "general" && (isHotStar || isStar) && (
          <Grid container>
            <Grid item xs sm md={2}></Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={8}
              data-testid={`Claimant-arbitration-questions`}
            >
              <Box height="1rem"></Box>
              <Typography
                style={{
                  textAlign: "justify",
                  margin: "2px",
                  paddingLeft: "14px",
                  paddingRight: "14px",
                }}
              >
                In your Grievance, to the extent possible, please indicate
                provisions of the relevant Laws / Rules invoked, Title / Name of
                Content (if any), Time-stamp details Of Content (i.e., specific
                time(s), Where the scene(s) appears / appear in the content (if
                any) and any other information or details that you deem
                necessary.
              </Typography>
              <Box height="1rem"></Box>
            </Grid>
            <Grid item xs sm md={2}></Grid>
          </Grid>
        )}
      </Box>

      <Box display="flex" justifyContent="center" p="1rem 0">
        {questions[0].for_profile_type === "respondent" && (
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              DocGenerator(activeDispute.id, "claimant");
            }}
          >
            Download Case file
          </Button>
        )}

        <Box width="2rem" />
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoBack}
          style={{marginRight: '1rem'}}
        >
          Back
        </Button>
        <DebouncedButton
          variant="outlined"
          color="primary"
          className={`${classes.button} ${(isHotStar || isStar || isMuthoot || isOrix) && classes.outlineButton}`}
          onClickHandler={onSubmit}
          disabled={answerLoading}
          loading={answerLoading}
          value={isMuthoot || isOrix ? 'Save Draft and Proceed' : <FormattedMessage id="buttons.submit" />}
          debounceTime={1000}
        />
      </Box>
    </React.Fragment>
  );
};

export default Questions;
